export class chartModel {
  label: string;
  type: any;
  data: any[];
  backgroundColor: string;
  borderColor?: string;
  borderWidth: number;
  fill?: boolean;
}
